<template>
  <div class="page-content">
    <page-template
      ref="discountTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title="折扣明细" :visible.sync="listShow" width="1200px" height="2000px" :close-on-click-modal="false">
      <list-operation :tableOptions="listColumns" ref="listOperation">
      </list-operation>
    </el-dialog>
    <el-dialog title="商品分析" :visible.sync="analyseShow" width="1200px" height="2000px" :close-on-click-modal="false">
      <list-operation :tableOptions="analyseColumns" ref="analyseOperation">
      </list-operation>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/config/api'
import pageTemplate from '@/components/template/pageTemplate';
import listOperation from '@/components/template/listOperation';
import userPower from '@/mixin/userPower'
export default {
  mixins: [userPower],
components:{pageTemplate,listOperation},
mounted() {
     
},
data(){
    return{
       listShow: false,
       analyseShow:false,
        searchOptions: {
          simple: [
            {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            span: 12,
            data: [],
            url: api.store.store,
          },
          ],
          complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
        ],
        },
         toolConfig: [
           {
                label: "导出",
                code: "export",
                callback: this.exportData
            },
          {
            label: '商品分析',
            type: this.$utils.buttonType.tableOperate,
            code: 'goodsAnalyse',
            callback:this.goodsAnalyse
          },
          {
            label: '记录',
            code: 'record',
            type: this.$utils.buttonType.tableOperate,
            callback: this.checkGoods,
          },
        ],
        tableOptions: {
          columns: [
            {label: '序号', prop: 'id', width: '50', align: 'center'},
            {label: '折扣名称', prop: 'code', width: '120', align: 'center'},
            {label: '单数', prop: 'name', width: '120', align: 'center'},
            {
              label: '原价总额',
              prop: 'status',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asBrand.status')
            },
            {label: '折让总数', prop: 'createBy', width: '120', align: 'center'},
            {label: '折让比例', prop: 'createDttm', width: '125', align: 'center'},
            {label: '营业额占比', prop: 'createDttm', width: '125', align: 'center'},
          ],
          url: api.archives.brand
        },
        //记录---弹框
        listColumns: {
        indexShow: true,//是否显示索引
        // summaryColumns: ['retailPrice', 'payPrice', 'goodsNum', 'allPrice'],
        columns:
          [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {
              label: '时间',
              prop: 'goodsName',
              // callback: this.getInfo,
              width: '100',
            },
            {
              label: '门店',
              prop: 'artNo',
              width: '100',

            },
            {
              label: '单号',
              prop: 'barCode',
              width: '100'
            },
            {
              label: '优惠券',
              prop: 'specs',
              width: '100'
            },

            {
              label: '导购员',
              prop: 'goodsUnitName',
              align: 'center',
              width: '110',
            },
            {
              label: '会员',
              prop: 'retailPrice',
              align: 'center',
              width: '110',
            },
            {
              label: '商品',
              prop: 'payPrice',
              align: 'center',
              width: '110',
            },
            {
              label: '规格',
              prop: 'goodsNum',
              align: 'center',
              width: '110',
            },
            {
              label: '数量',
              prop: 'allPrice',
              align: 'center',
              width: '110',
            },
             {
              label: '原价',
              prop: 'allPrice',
              align: 'center',
              width: '110',
            },

           {
              label: '折让',
              prop: 'allPrice',
              align: 'center',
              width: '110',
            },
             {
              label: '折让比例',
              prop: 'allPrice',
              align: 'center',
              width: '110',
            },
          ],
        // url: api.retail.retailSearch,
      },
      //商品分析--弹框
          analyseColumns: {
        indexShow: true,//是否显示索引
        // summaryColumns: ['retailPrice', 'payPrice', 'goodsNum', 'allPrice'],
        columns:
          [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {
              label: '商品',
              prop: 'goodsName',
              // callback: this.getInfo,
              width: '100',
            },
            {
              label: '规格',
              prop: 'artNo',
              width: '100',

            },
            {
              label: '数量',
              prop: 'barCode',
              width: '100'
            },
            {
              label: '原价',
              prop: 'specs',
              width: '100'
            },

            {
              label: '折让',
              prop: 'goodsUnitName',
              align: 'center',
              width: '110',
            },
            {
              label: '会折让比例',
              prop: 'retailPrice',
              align: 'center',
              width: '110',
            },
          ],
        url: api.retail.retailSearch,
      },

    }
},
created() {
    this.setStore(this.searchOptions.simple);
  },
methods:{
 checkGoods(row) {
        this.$axios.fetchPost(api.member.depositRecord + '/list', {memberId: row.id}).then(data => {
          if (data.code === 200) {
            if (data.data.length > 0) {
              this.listShow = true;
              this.$nextTick(() => {
                this.$refs['listOperation'].addMoreRow(data.data, 0);
              });
            } else {
              this.listShow = true;
              this.$refs['listOperation'].clearTableData();
            }
          }
        }).catch(err => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
        })
      },
  goodsAnalyse(row) {
      this.$axios.fetchPost(api.member.depositRecord + '/list', {memberId: row.id}).then(data => {
          if (data.code === 200) {
            if (data.data.length > 0) {
              this.analyseShow = true;
              this.$nextTick(() => {
                this.$refs['analyseOperation'].addMoreRow(data.data, 0);
              });
            } else {
              this.analyseShow = true;
              this.$refs['analyseOperation'].clearTableData();
            }
          }
        }).catch(err => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
        })
},
}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/report/sales/Discount.vue